module.exports = __webpack_public_path__ + "img/25.4b021c4d.jpg";